import { CloudLightning } from 'lucide-react';
import { Tabs, TabsContent, TabsList, TabsTrigger } from '@/components/ui/tabs';
import { useSearchParams } from 'react-router-dom';
import { LiveStormMap } from '@/components/storm-watch/LiveStormMap';
import { AddressReportTab } from '@/components/storm-watch/AddressReportTab';
import { AlertZonesTab } from '@/components/storm-watch/AlertZonesTab';
import { SavedReportsTab } from '@/components/storm-watch/SavedReportsTab';

export default function StormMap() {
  const [params, setParams] = useSearchParams();
  const tab = params.get('tab') || 'live';

  return (
    <div className="p-4 md:p-6 space-y-6">
      <div className="flex items-start justify-between gap-4 flex-wrap">
        <div className="flex items-center gap-3">
          <div className="p-2.5 rounded-xl bg-gradient-to-br from-sky-500 to-purple-600 shadow-lg">
            <CloudLightning className="w-6 h-6 text-white" />
          </div>
          <div>
            <h1 className="text-2xl md:text-3xl font-bold">Storm Watch</h1>
            <p className="text-sm text-muted-foreground">Real-time hail tracking, address reports, and storm alerts powered by NOAA</p>
          </div>
        </div>
      </div>

      <Tabs value={tab} onValueChange={(v) => setParams({ tab: v })}>
        <TabsList className="grid w-full max-w-2xl grid-cols-4">
          <TabsTrigger value="live">Live Map</TabsTrigger>
          <TabsTrigger value="address">Address Report</TabsTrigger>
          <TabsTrigger value="zones">Alert Zones</TabsTrigger>
          <TabsTrigger value="saved">Saved</TabsTrigger>
        </TabsList>

        <TabsContent value="live" className="mt-4"><LiveStormMap /></TabsContent>
        <TabsContent value="address" className="mt-4"><AddressReportTab /></TabsContent>
        <TabsContent value="zones" className="mt-4"><AlertZonesTab /></TabsContent>
        <TabsContent value="saved" className="mt-4"><SavedReportsTab /></TabsContent>
      </Tabs>
    </div>
  );
}
